import {
	isProductKey,
	type PrimaryProductKey,
	type ProductKeys,
} from '../../common/constants/products';

export const getProductToSelect = (params: {
	isUniversal?: boolean;
	primaryProduct?: PrimaryProductKey;
	productToSet?: ProductKeys;
	selectedProduct?: ProductKeys;
}) => {
	if (params.productToSet || params.isUniversal) {
		return params.productToSet;
	}

	const productToSelect = params.selectedProduct ?? params.primaryProduct ?? '';
	const safeProductKey = isProductKey(productToSelect) ? productToSelect : undefined;
	return safeProductKey;
};
